import React from 'react';
import { ContributionSummary, ProductsList } from '@components/common';
import { ButtonClean, PriceString, Tag } from '@fourthwall/components';
import { pluralize } from '@fourthwall/utils/dist/string';
import { YOU_FULFILL } from '@modules/Dashboard/Product/Product.consts';
import { TimezonedDateString } from '../../../../../../../../../Timezone/components/TimezonedDateString';
import * as S from './ShipmentItem.styled';
const titleDateFormat = 'MMM D, YYYY';
export const ShipmentItem = ({ shipment, createdAt, deliveryIndex, allDeliveriesCount, }) => {
    const isSelfFulfilled = YOU_FULFILL.includes(shipment.fulfillmentService);
    const isDigital = shipment.fulfillmentService === 'DIGITAL_ITEM';
    const statusMap = {
        NOT_SHIPPED: {
            label: 'Not shipped',
            appearance: 'default',
        },
        SHIPPED: {
            label: 'Shipped',
            appearance: 'success',
        },
        DELIVERED: {
            label: 'Delivered',
            appearance: 'success',
        },
    };
    const getDescription = () => {
        if (isDigital)
            return null;
        if (shipment.status === 'NOT_SHIPPED' && isSelfFulfilled) {
            return 'To be shipped by you';
        }
        if (shipment.status === 'NOT_SHIPPED' && !isSelfFulfilled) {
            return 'Fulfilled by Fourthwall';
        }
        return (React.createElement(S.ShippedLabel, null,
            shipment.reshipment && (React.createElement(React.Fragment, null,
                React.createElement("span", null, "Reshipment"),
                React.createElement("span", null, " | "))),
            !shipment.reshipment && allDeliveriesCount > 1 && (React.createElement(React.Fragment, null,
                React.createElement("span", null,
                    "Delivery ",
                    deliveryIndex,
                    " of ",
                    allDeliveriesCount),
                React.createElement("span", null, " | "))),
            React.createElement("span", null, isSelfFulfilled ? 'Shipped by you' : 'Shipped by Fourthwall')));
    };
    const renderDeliveryDate = () => {
        if ('dateFrom' in shipment.deliveryStatus && 'dateTo' in shipment.deliveryStatus) {
            return (React.createElement(React.Fragment, null,
                React.createElement(TimezonedDateString, { date: shipment.deliveryStatus.dateFrom, format: titleDateFormat }),
                " -",
                ' ',
                React.createElement(TimezonedDateString, { date: shipment.deliveryStatus.dateTo, format: titleDateFormat })));
        }
        if (`date` in shipment.deliveryStatus) {
            return React.createElement(TimezonedDateString, { date: shipment.deliveryStatus.date, format: titleDateFormat });
        }
        return null;
    };
    const getTitle = () => {
        if (isDigital)
            return `Digital ${pluralize(shipment.offers.length, 'item')}`;
        switch (shipment.deliveryStatus.type) {
            case 'DeliveredAt':
                return React.createElement(React.Fragment, null,
                    "Delivered on ",
                    renderDeliveryDate());
            case 'DeliveryEstimationDateRange':
                return React.createElement(React.Fragment, null,
                    "Estimated delivery ",
                    renderDeliveryDate());
            case 'ShippedOn':
                return React.createElement(React.Fragment, null,
                    "Shipped on ",
                    renderDeliveryDate());
            case 'ArrivesOn':
                return React.createElement(React.Fragment, null,
                    "Arrives on ",
                    renderDeliveryDate());
            case 'ArrivesBetween':
                return React.createElement(React.Fragment, null,
                    "Arrives ",
                    renderDeliveryDate());
            case 'Unknown':
                return (React.createElement(React.Fragment, null,
                    "Order placed on ",
                    React.createElement(TimezonedDateString, { date: createdAt, format: titleDateFormat })));
        }
    };
    const getSubtitle = () => {
        if (shipment.shipmentTracker?.trackingCode) {
            return (React.createElement(React.Fragment, null,
                "Tracking number:",
                ' ',
                shipment.shipmentTracker?.url ? (React.createElement(ButtonClean, { label: shipment.shipmentTracker?.trackingCode, target: "_blank", href: shipment.shipmentTracker?.url })) : (React.createElement("span", null, shipment.shipmentTracker?.trackingCode))));
        }
    };
    const renderOffer = ({ variant, offer, quantity, price }) => (React.createElement(ProductsList.Item, { key: variant?.id, image: offer.thumbnailImage, offerId: offer?.id, name: offer?.name, variants: variant.attributesDescription, quantity: quantity, price: React.createElement(PriceString, { value: price.value }) }));
    return (React.createElement(ContributionSummary, { description: getDescription(), title: getTitle(), subtitle: getSubtitle(), status: React.createElement(Tag, { ...statusMap[shipment.status] }) },
        React.createElement(ContributionSummary.Section, null,
            React.createElement(ProductsList, { size: "large" }, shipment.offers?.map(renderOffer)))));
};
